import $ from 'jquery'

import Block from '../block'

export default class Size extends Block {
	static title = 'size'

	constructor($el) {
		super($el)

		this.$el.findElement('input').change((event) => this.handleChange(event))
	}

	handleChange(event) {
		$(document).trigger('size:change', {
			id: event.target.value,
			name: this.$el.data('title'),
			remove: !event.target.checked,
		})
	}
}
